var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_318_540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.42249 7.71333C6.74833 8.03916 6.74833 8.56666 6.42249 8.89166C6.09666 9.2175 5.56916 9.2175 5.24416 8.89166C4.91833 8.56583 4.91833 8.03833 5.24416 7.71333C5.56999 7.3875 6.09749 7.3875 6.42249 7.71333ZM17.9658 12.7842L17.495 13.255C17.4725 14.2825 17.0742 15.3025 16.2992 16.0875L13.66 18.7608C12.8742 19.5567 11.8258 19.9967 10.7075 20H10.6933C9.58083 20 8.53499 19.5667 7.74833 18.78L1.56833 12.6525C1.02666 12.1117 0.764994 11.3675 0.848328 10.6083L1.48583 4.845C1.52833 4.465 1.82249 4.1625 2.20083 4.11083L7.94166 3.32583C8.71833 3.2225 9.49999 3.48666 10.0483 4.035L16.2775 10.2117C16.6 10.5342 16.8583 10.8975 17.0533 11.285C17.73 10.3133 17.635 8.95583 16.7683 8.08916L10.4425 1.91833C10.2517 1.7275 9.98833 1.63916 9.73333 1.675L3.99249 2.46C3.53499 2.52166 3.11583 2.2025 3.05333 1.7475C2.99166 1.29166 3.31083 0.871665 3.76583 0.809165L9.50749 0.0233313C10.275 -0.0858353 11.065 0.182498 11.6142 0.733331L17.9383 6.90416C19.56 8.525 19.5692 11.16 17.965 12.785L17.9658 12.7842ZM15.1008 11.3925L8.87166 5.21583C8.68583 5.03 8.42499 4.94416 8.16583 4.97666L3.06999 5.67416L2.50416 10.7908C2.47666 11.0433 2.56333 11.2917 2.74333 11.4708L8.92333 17.5983C9.39749 18.0733 10.025 18.3325 10.6925 18.3325H10.7008C11.3725 18.3308 12.0017 18.0667 12.4725 17.5883L15.1117 14.915C16.0742 13.94 16.0692 12.3592 15.1 11.3908L15.1008 11.3925Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "black"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/Tags.a8de31047b750368e2db7984167aaaf0.svg";
export { ForwardRef as ReactComponent };